module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service_suggest.firmware":"แนะนำให้ Update Firmware เป็น Version ล่าสุด ({firmware})"}}')
  delete Component.options._Ctor
}
